import { relations } from 'drizzle-orm';
import { healthRecordUploads } from '../models/healthRecordUploads';
import { ehrIntegrations } from '../models/ehrIntegrations';
import { patientProfiles } from '../../patient/models/patientProfiles';

/**
 * @group Relations
 * @summary Health record upload relations for the database schema
 *
 * @remarks
 * Defines the relationships for the healthRecordUploads table, including the many-to-one
 * relationships with patient profiles and EHR integrations.
 *
 * @example
 * ```typescript
 * import { healthRecordUploadRelations } from '@shared/db';
 *
 * // Query health record upload with patient and integration
 * const uploadWithDetails = await db.query.healthRecordUploads.findFirst({
 *   where: eq(healthRecordUploads.id, uploadId),
 *   with: {
 *     patient: true,
 *     ehrIntegration: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
healthRecordUploadRelations = relations(healthRecordUploads, ({ one }) => ({
  patient: one(patientProfiles, {
    fields: [healthRecordUploads.patientId],
    references: [patientProfiles.id],
  }),
  ehrIntegration: one(ehrIntegrations, {
    fields: [healthRecordUploads.ehrIntegrationId],
    references: [ehrIntegrations.id],
  }),
}));
